<template>
  <section class="page-wrapper">
    <div class="error-content">
      <div class="flex-column align-center">
        <alert-circle-icon size="4.0x" class="alert-circle small-buffer" />
        <h3 class="small-buffer">
          Sorry, an unexpected error occurred loading this content.
        </h3>
      </div>
      <p class="small-buffer">
        We are aware there is an issue and are working to fix it.
      </p>
      <p class="small-buffer">
        Try <a href="" @click.prevent="refresh">refreshing the page</a>, if that
        does not work please come back later.
      </p>
    </div>
  </section>
</template>

<script>
  import { AlertCircleIcon } from "vue-feather-icons";
  export default {
    name: "UpdoxError",
    components: { AlertCircleIcon },
    props: {
      errorDetails: {
        type: Object,
        required: false,
      },
    },
    computed: {
      error: function () {
        return console.error("UpdoxError called", this.errorDetails);
        // return {
        //     id: this.errorDetails?.formId || 0,
        //     title: this.errorDetails?.formTitle || "",
        //     name: this.errorDetails?.practiceName || "",
        //     errorType: this.errorDetails?.errorType || ""
        // };
      },
    },
    methods: {
      refresh() {
        location.reload();
      },
    },
  };
</script>
<style lang="scss">
  .alert-circle {
    color: red;
  }
  .strong-highlight {
    background-color: yellow;
  }
  .small-buffer {
    margin-bottom: 5px;
  }
</style>
